import React, { useState, useLayoutEffect } from 'react';
import RolesList from '../../Components/Roles/RolesListing/RolesList';
import { useSidebar } from '../../Context/SidebarContext/SidebarContext';
import GeneralSettings from '../../Components/SettingsItems/GeneralSettings/GeneralSettings';
import JobSettings from '../../Components/SettingsItems/JobSettings/JobSettings';
import InvoiceSettings from '../../Components/SettingsItems/InvoiceSettings/InvoiceSettings';
import EmailSettings from '../../../../../Pages/EmailSettings/EmailSettings';

const Settings = () => {
  const { setActiveTab } = useSidebar();
  const [settingsTab, setSettingsTab] = useState("General Settings");

  useLayoutEffect(() => {
    setActiveTab("Settings");
  }, [setActiveTab]);

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="common-top">
            <div className="ct-tabs mt-0">
              <ul className="nav nav-tabs jtabs" role="tablist">
                <li className="nav-item">
                  <button
                    className={`nav-link ctt-button ${settingsTab === "General Settings" ? "active" : ""}`}
                    onClick={() => {
                      setSettingsTab("General Settings");
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24.729" height="21.703" viewBox="0 0 24.729 21.703">
                      <g id="Group_1235" data-name="Group 1235" transform="translate(0.002 -1.312)">
                        <path id="fill-change" data-name="Path 1253" d="M7.713,3.2a1.092,1.092,0,0,1,.973-.573l2.164.033a1.092,1.092,0,0,1,.952.6L12.667,5l1.529-.13a1.092,1.092,0,0,1,1,.493L16.29,7.056a1.082,1.082,0,0,1-.031,1.216l-.8,1.125.855,1.129a1.081,1.081,0,0,1,.066,1.208l-1.03,1.727a1.092,1.092,0,0,1-.993.525l-1.618-.1-1,2.038a1.092,1.092,0,0,1-.973.606H8.537a1.092,1.092,0,0,1-.971-.606l-.936-1.914L4.9,14.167a1.092,1.092,0,0,1-1.016-.507L2.79,11.9a1.082,1.082,0,0,1,.062-1.23L3.841,9.38l-.8-1.111a1.082,1.082,0,0,1-.029-1.216L4.109,5.36a1.092,1.092,0,0,1,1-.493l1.642.14Zm1.232.977L7.973,6a1.092,1.092,0,0,1-1.047.571L5.257,6.433l-.771,1.2L5.3,8.762a1.082,1.082,0,0,1-.021,1.288L4.272,11.357l.775,1.249,1.764-.161a1.082,1.082,0,0,1,1.072.6l.946,1.939h1.649l1.006-2.055a1.092,1.092,0,0,1,1.037-.6l1.645.1.725-1.216-.874-1.154A1.082,1.082,0,0,1,14,8.774l.822-1.146-.771-1.2-1.566.132a1.082,1.082,0,0,1-1.061-.6L10.543,4.2Z" transform="translate(2.787 2.551)" fill="#111" fill-rule="evenodd" />
                        <path id="fill-change" data-name="Path 1254" d="M21.19,14.454a9.274,9.274,0,0,1-17.859-.775l1.754-.346L1.747,9.879,0,14.345l1.849-.363a10.819,10.819,0,0,0,20.865.95ZM22.913,9.22A10.819,10.819,0,0,0,2.047,8.272l1.469.478a9.273,9.273,0,0,1,17.859.773l-1.754.348,3.338,3.446,1.768-4.46Z" transform="translate(-0.001 0.562)" fill="#111" />
                        <path id="fill-change" data-name="Path 1255" d="M7.193,6.421a.773.773,0,1,0,.546.226A.773.773,0,0,0,7.193,6.421Zm-2.318.773a2.318,2.318,0,1,1,.679,1.639A2.318,2.318,0,0,1,4.875,7.193Z" transform="translate(5.172 4.938)" fill="#111" fill-rule="evenodd" />
                      </g>
                    </svg>

                    <span>General Settings</span>
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className={`nav-link ctt-button ${settingsTab === "Job Settings" ? "active" : ""}`}
                    onClick={() => {
                      setSettingsTab("Job Settings");
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <g id="healthicons_miner-worker-outline" transform="translate(-3 -3)">
                        <path id="fill-change" data-name="Path 1196" d="M12.611,3a.555.555,0,0,1,.556.556v.038a5.423,5.423,0,0,1,3.513,1.681,3.93,3.93,0,0,1,.993,1.962l.06.046a1.944,1.944,0,0,1,.974,1.743,1.882,1.882,0,0,1-1.239,1.287q-.207.092-.422.164.01.148.01.3a4.444,4.444,0,1,1-8.879-.3q-.215-.073-.422-.164A1.882,1.882,0,0,1,6.516,9.026a1.944,1.944,0,0,1,.974-1.743l.071-.054q.021-.133.053-.263A4.222,4.222,0,0,1,8.4,5.38a4.88,4.88,0,0,1,3.658-1.813V3.556A.556.556,0,0,1,12.611,3Zm4.256,5.8a.556.556,0,0,0,.64-.2c.109.153.106.234.1.247-.007.044-.092.228-.592.449a8.77,8.77,0,0,1-2.465.55,1.944,1.944,0,0,0-3.884,0A8.77,8.77,0,0,1,8.2,9.3c-.5-.221-.584-.4-.592-.449,0-.013-.006-.093.1-.247a.556.556,0,0,0,.972-.517,1.537,1.537,0,0,1,.005-.857,3.111,3.111,0,0,1,.579-1.162l.006-.008V7.167a.556.556,0,1,0,1.111,0V5.137a4.159,4.159,0,0,1,1.667-.457V6.056a.556.556,0,1,0,1.111,0V4.712a4.739,4.739,0,0,1,1.667.517V7.167a.556.556,0,1,0,1.111,0V6.122a2.17,2.17,0,0,1,.589,1.967.555.555,0,0,0,.333.711ZM11.2,11.286a15.555,15.555,0,0,1-1.916-.242,3.333,3.333,0,0,0,6.646,0,15.61,15.61,0,0,1-1.916.242,1.944,1.944,0,0,1-2.814,0Zm2.241-1.342a.833.833,0,1,1-.244-.589A.833.833,0,0,1,13.444,9.944Z" transform="translate(0.389 0)" fill="#111" fillRule="evenodd" />
                        <path id="fill-change" data-name="Path 1197" d="M12.111,19.722a1.111,1.111,0,1,0-.786-.325A1.111,1.111,0,0,0,12.111,19.722Z" transform="translate(0.889 1.611)" fill="#111" />
                        <path id="fill-change" data-name="Path 1198" d="M10.519,14.2l1.926,1.444h1.111L15.481,14.2C18.867,14.742,23,16.25,23,18.422v3.333H3V18.422C3,16.25,7.133,14.742,10.519,14.2Zm3.407,2.556,1.839-1.379c.557.1,1.124.231,1.679.381v4.887h1.111V16.1c.389.133.762.278,1.111.434v4.113H6.333V16.532c.349-.156.722-.3,1.111-.434v4.547H8.556V15.757c.555-.151,1.122-.279,1.679-.381l1.839,1.379Zm7.577.939a1.088,1.088,0,0,1,.386.728v2.222H20.778V17.12a4.029,4.029,0,0,1,.725.575M4.5,17.7a4.094,4.094,0,0,1,.725-.574v3.524H4.111V18.422a1.086,1.086,0,0,1,.386-.728" transform="translate(0 1.244)" fill="#111" fillRule="evenodd" />
                      </g>
                    </svg>
                    <span>Job Settings</span>
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className={`nav-link ctt-button ${settingsTab === "Invoice Settings" ? "active" : ""}`}
                    onClick={() => {
                      setSettingsTab("Invoice Settings");
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.467" height="20.5"
                      viewBox="0 0 20.467 20.5">
                      <g id="hugeicons_invoice-03" transform="translate(-1.25 -1.25)">
                        <path id="stroke-change" data-name="Path 1202"
                          d="M19.915,2C18.858,2,18,4.552,18,7.7h1.915c.923,0,1.384,0,1.67-.318s.236-.739.137-1.578C21.458,3.586,20.749,2,19.915,2Z"
                          transform="translate(-0.8)" fill="none" stroke="#111" stroke-linecap="round"
                          stroke-linejoin="round" stroke-width="1.5" />
                        <path id="stroke-change" data-name="Path 1203"
                          d="M17.2,7.751V17.814c0,1.435,0,2.154-.439,2.437-.717.462-1.826-.507-2.384-.859a2.093,2.093,0,0,0-.946-.444c-.276-.01-.511.13-1.009.444l-1.815,1.145c-.49.309-.734.464-1.007.464s-.518-.155-1.007-.464L6.779,19.392a2.1,2.1,0,0,0-.947-.444c-.276-.01-.511.13-1.009.444-.558.352-1.666,1.321-2.385.859C2,19.967,2,19.25,2,17.814V7.751c0-2.711,0-4.066.835-4.909S5.013,2,7.7,2H19.1M5.8,5.8h7.6M7.7,9.6H5.8"
                          fill="none" stroke="#111" stroke-linecap="round" stroke-linejoin="round"
                          stroke-width="1.5" />
                        <path id="stroke-change" data-name="Path 1204"
                          d="M12.425,10.831A1.345,1.345,0,0,0,11,12.079a1.345,1.345,0,0,0,1.425,1.246,1.345,1.345,0,0,1,1.425,1.247,1.345,1.345,0,0,1-1.425,1.246m0-4.987a1.427,1.427,0,0,1,1.344.831m-1.344-.831V10m0,5.819a1.427,1.427,0,0,1-1.344-.831m1.344.831v.831"
                          transform="translate(-0.45 -0.4)" fill="none" stroke="#111"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                      </g>
                    </svg>
                    <span>Invoice Settings</span>
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className={`nav-link ctt-button ${settingsTab === "Email Settings" ? "active" : ""}`}
                    onClick={() => {
                      setSettingsTab("Email Settings");
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                      <g transform="translate(0 0)">
                        <path
                          id="fill-change"
                          d="M3.75 5A1.75 1.75 0 0 0 2 6.75v10.5A1.75 1.75 0 0 0 3.75 19h16.5A1.75 1.75 0 0 0 22 17.25V6.75A1.75 1.75 0 0 0 20.25 5Zm0 1.5h16.5a.25.25 0 0 1 .22.14l-7.9 4.94a2.25 2.25 0 0 1-2.1 0L3.53 6.64a.25.25 0 0 1 .22-.14Zm-.25 2.36 6.71 4.2a3.75 3.75 0 0 0 3.58 0l6.71-4.2v7.39a.25.25 0 0 1-.25.25H3.75a.25.25 0 0 1-.25-.25Z"
                          fill="#111"
                        />
                      </g>
                    </svg>
                    <span>Email Settings</span>
                  </button>
                </li>

                <li className="nav-item">
                  <button
                    className={`nav-link ctt-button ${settingsTab === "Roles" ? "active" : ""}`}
                    onClick={() => {
                      setSettingsTab("Roles");
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.997" height="19.999" viewBox="0 0 19.997 19.999">
                      <g id="Group_1237" data-name="Group 1237" transform="translate(-0.479 -0.478)">
                        <path id="fill-change" data-name="Path 1256" d="M12.3,1.93a1.875,1.875,0,1,0-.144,1.25,7.5,7.5,0,0,1,5.3,4.541l1.143-.45A8.748,8.748,0,0,0,12.3,1.93ZM10.481,2.985a.624.624,0,1,1,.442-.182A.625.625,0,0,1,10.481,2.985ZM7.733,3.5,7.271,2.361a8.748,8.748,0,0,0-5.341,6.3,1.875,1.875,0,1,0,1.25.144A7.5,7.5,0,0,1,7.733,3.5Zm-5.372,7.6a.625.625,0,1,1,.442-.183A.625.625,0,0,1,2.36,11.107Zm8.121,5.622a1.874,1.874,0,0,0-1.674,1.044,7.5,7.5,0,0,1-5.3-4.541l-1.143.462a8.748,8.748,0,0,0,6.321,5.341,1.874,1.874,0,1,0,1.8-2.3Zm0,2.5a.625.625,0,1,1,.442-.183A.625.625,0,0,1,10.481,19.227Zm9.994-8.746a1.875,1.875,0,1,0-2.7,1.674,7.5,7.5,0,0,1-4.541,5.3l.463,1.143a8.747,8.747,0,0,0,5.341-6.321,1.874,1.874,0,0,0,1.443-1.8Zm-1.875.625a.625.625,0,1,1,.442-.183A.625.625,0,0,1,18.6,11.106Z" transform="translate(0 0)" fill="#111" />
                        <path id="fill-change" data-name="Path 1257" d="M10.684,9.134a2.5,2.5,0,1,0-3.491,0A3.124,3.124,0,0,0,5.818,11.72v1.249h6.247V11.72a3.122,3.122,0,0,0-1.38-2.585ZM7.692,7.347a1.25,1.25,0,1,1,.366.884A1.25,1.25,0,0,1,7.692,7.347ZM7.067,11.72a1.875,1.875,0,1,1,3.748,0Z" transform="translate(1.54 1.26)" fill="#111" />
                      </g>
                    </svg>

                    <span>Roles</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
          <div className="main-inner">
            <div style={{ display: settingsTab === "General Settings" ? 'block' : 'none' }}>
              <div className="general-settings-container">
                <GeneralSettings />
              </div>
            </div>
            <div style={{ display: settingsTab === "Job Settings" ? 'block' : 'none' }}>
              <div className="job-settings-container">
                <JobSettings />
              </div>
            </div>
            <div style={{ display: settingsTab === "Invoice Settings" ? 'block' : 'none' }}>
              <div className="job-settings-container">
                <InvoiceSettings />
              </div>
            </div>
            <div style={{ display: settingsTab === "Email Settings" ? 'block' : 'none' }}>
              <div className="email-settings-full">
                <EmailSettings />
              </div>
            </div>
            <div style={{ display: settingsTab === "Roles" ? 'block' : 'none' }} >
              <RolesList />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Settings;
